
import { ValidationSet } from '../../../types/validation';
import { hasMatchingBrackets } from '../string';
import { variableScope } from './variable-scope';

const hasVariableRegex = new RegExp('(?<!{{)\\b(' + variableScope + ')\\.\\w+\\b|\\b(' + variableScope + ')\\.\\w+\\b(?!}})');

export const hasVariableRules: ValidationSet = [
  {
    message: 'Variables can only be used inside double curly braces. Eg: {{app.variable}}.',
    test: (value: string) => {
      return hasVariableRegex.test(value);
    }
  },
  {
    message: 'Curly braces are not properly opened or closed.',
    test: (value: string) => !hasMatchingBrackets(value)
  }
];
